/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Represents ComponentsBuilder
 */
class ComponentsBuilder {
	/**
	 * Builds react components tree
	 * @param config Config to build tree from
	 * @returns {React.FC|null}
	 */
	build(config: object|null = {}): object {
		return null;
	}
}

export default ComponentsBuilder;
